'use es6';

import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
export const DEFAULT_PROPS = {
  buttonSize: 'default',
  buttonUse: 'form',
  clearable: false,
  open: false,
  ignoreAccents: true,
  ignoreCase: true,
  inputComponent: SearchInput,
  itemComponent: 'span',
  resetValue: '',
  searchable: true,
  value: ''
};
export const INITIAL_STATE = {
  controlWidth: 0,
  initiallyOpen: false,
  inputValue: '',
  optionsStack: [],
  prevOpen: false,
  resetOption: null,
  searchableOptions: null,
  value: ''
};